import styled from 'styled-components'
import { NumericFormat } from 'react-number-format'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`

export const LabelRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr repeat(3, 2fr);
  justify-content: center;
  align-items: flex-end;
  justify-items: center;
  margin-bottom: 5px;
  padding: 0px 15px;
  width: 100%;
`

export const Image = styled.img`
  width: 20px;
  height: 20px;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: center;
  margin-bottom: 0px;
`

export const Title = styled(InfoText)`
  font-size: 16px;
  font-weight: bold;
  padding: 0px;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
`

export const MoneyTextMask = styled(NumericFormat).attrs (props => {
  return {
    value: props.value.toFixed (2).replace ('.', ','),
    thousandSeparator: '.',
    decimalSeparator: ',',
    displayType: 'text',
    prefix: 'R$ '
  }
})`
  color: ${({value}) => parseFloat (value.replace (',', '.')) >= 0 ? '#44CF6C' : '#FF3939'};
  font-size: 16px;
  font-weight: bold;
  line-height: 14px;
  margin-bottom: 0px;
  padding: 0px;
`

export const EarningContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 2fr 1fr 2fr 2fr 2fr;
  background-color: #FFFFFF;
  box-shadow: 0px 2px 10px -6px #252525;
  justify-content: center;
  align-items: center;
  justify-items: center;
  border-radius: 15px;
  margin-bottom: 10px;
  padding: 0px 15px;
  height: 40px;

  p {
    line-height: 16px;
    align-self: center;
    justify-self: center;
  }
`
